// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__OHVuY","author":"Table_author__3pEG0","authorImage":"Table_authorImage__15Dyc","unreadRow":"Table_unreadRow__3H00e"};